<div (swipe)="onSwipe($event)" class="tutorial-container text-center">
    <h1 tabindex="0" class="tutorial-header">Earn Free Food when you Order Online or Scan</h1>
    <hr>
    <div class="img-container">
        <div ngClass={{config[step-1].step}} alt="feature image" class="tutorial-feature" ></div>
    </div>
    <p tabindex="0" class="tutorial-content">{{config[step-1].content}}</p>
    <strong [ngClass]="{'link-container': !isUserSignedIn}">
        <a role="button" *ngIf="config[step-1].tutorialLinkText" class="tutorial-link" (click)="goToScreen(step)">What Can I Earn?</a>
    </strong>
    
    <ul [ngClass]="{'paginator-signedin': isUserSignedIn, 'paginator-guest': !isUserSignedIn}" class="paginator">
        <a tabindex="0" [ngClass]="{'disable-link': step == 1}" [attr.aria-disabled]="step == 1" aria-label="View Previous Screen" (click)="moveStep(-1)">
            <span [ngClass]="{'disable-link': step == 1}" class="left-chevron"></span>
        </a>
        <li role="button" tabindex="0" *ngFor="let item of config; let i = index" [ngClass]="{'active': item.step == step}" [attr.aria-label]="'View Screen '+ item.step" (click)="goToStep(config[i].step)"></li>        
        <a tabindex="0" [ngClass]="{'disable-link': step == config.length}" [attr.aria-disabled]="step == config.length"  aria-label="View Next Screen" (click)="moveStep(1)">
            <span [ngClass]="{'disable-link': step == config.length}" class="right-chevron"></span>
        </a>
    </ul>
    <div *ngIf="!isUserSignedIn" class="cta-container">
        <div class="row">
            <hr>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button (click)="redirectToRewards()" class="btn wb-btn-default center-block">
                  Sign In
                  <span *ngIf="loading" class="loading-animation"></span>
                </button>
              </div>
        </div>
        <div *ngIf="!isUserSignedIn" class="row">       
            <div class="col-md-12 text-center mg-top-18">
              <span (click)="showSignupModal()" role="button" class="forget-sign-link">Create Account</span>
            </div>
        </div>
    </div>    
</div>